module.exports = __webpack_public_path__ + "static/bgImage-8e646142c563d89b61c8e7f0aeca70c8.jpg";